import { Component, OnInit} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { AssetOrderService } from '../../services/asset-order.service';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { AssetOrder } from '../../models/entities/asset-order';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';


@Component({
    selector: 'asset-order-list-mobile',
    templateUrl: './asset-order-list-mobile.component.html',
    styleUrls: ['./asset-order-list-mobile.component.scss']
})

export class AssetOrderListMobileComponent implements OnInit {

  assetOrders          : AssetOrder[] = [];
  selectedRow          : AssetOrder = null;
  listFields          = [];

  constructor(
    protected assetOrderService : AssetOrderService,
    protected toastr                 : ToastrService,
    protected router                 : Router,
    protected baseService            : BaseService,
    protected leanUtilsService       : LeanUtilsService,
    protected location               : Location,
    protected activatedRoute         : ActivatedRoute,) {
 //    super(toastr, router, baseService, leanUtilsService, location);
  }


  ngOnInit(){
  
//    this.baseService.fieldsGet("assetOrderMobile").then(result => {
//      this.listFields = result.listFields;
//      }
//    );
   
this.listFields  = [  
  { prop: 'assetOrderCode',     name: 'N° Bon commande' },
  { prop: 'theDate',            name: 'Date',           type : 'date' },
]

    this.assetOrderService.assetOrdersGet(null, null, null, true).then(result => {
      this.assetOrders = result;
      })
  }

  returnBack(){
    this.location.back();
  }
  
}
